<template>
  <!-- Error boundary catches config validation errors and shows user-friendly message -->
  <ConfigErrorBoundary>
    <FileConverter
      :config="converterConfig"
      @batch-created="handleBatchCreated"
      @job-completed="handleJobCompleted"
      @batch-cleared="handleBatchCleared"
      @error="handleError"
      @credits-updated="handleCreditsUpdated"
    >
      <!-- Optional: Override slots for font-specific formatting -->
      <!-- Using default for now, but can be customized here -->
    </FileConverter>
  </ConfigErrorBoundary>
</template>

<script setup lang="ts">
import FileConverter from './FileConverter.vue';
import ConfigErrorBoundary from './ConfigErrorBoundary.vue';
import { parseAndValidateConverterConfig } from '../utils/ConfigValidator';

// Parse and validate configuration using fail-fast Zod validation
// This replaces the old manual JSON parsing + lazy fallbacks pattern
// If config is invalid, parseAndValidateConverterConfig() throws with detailed error
// NOTE: jobCategory, labels, and creditCost are now provided by backend
const converterConfig = parseAndValidateConverterConfig('ttf-to-woff2-converter', 'TTF → WOFF2');

// Event handlers (optional - for font-specific analytics or side effects)
function handleBatchCreated(batchId: string) {
  console.log('[TTF-to-WOFF2 Converter] Batch created:', batchId);
}

function handleJobCompleted(jobId: string) {
  console.log('[TTF-to-WOFF2 Converter] Job completed:', jobId);
}

function handleBatchCleared() {
  console.log('[TTF-to-WOFF2 Converter] Batch cleared');
}

function handleError(error: Error) {
  console.error('[TTF-to-WOFF2 Converter] Error:', error);
}

function handleCreditsUpdated(credits: number) {
  console.log('[TTF-to-WOFF2 Converter] Credits updated:', credits);
}
</script>
